<table [formGroup]="formGroup">
    <tbody formGroupName="permissions">
        <tr>
            <td colspan="5">
                <app-form-error [parentForm]="formGroup" [controlPath]="'permissions'" />
            </td>
        </tr>
        <ng-container formGroupName="listings">
            <tr>
                <td colspan="5">
                    <app-form-error [parentForm]="formGroup" [controlPath]="'permissions.listings'" />
                </td>
            </tr>
            <tr>
                <th>{{ 'users.userGroups.createEdit.accessSettings.headings.main.listings' | translate }}</th>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.read' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.edit' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.create' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.delete' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.publish' | translate }}</td>
            </tr>
            <tr formGroupName="listings">
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.listings' | translate }}</td>
                <td><input type="checkbox" formControlName="read" (change)="onReadChange($event)" /></td>
                <td><input type="checkbox" formControlName="edit" (change)="onEditChange($event)" /></td>
                <td><input type="checkbox" formControlName="create" /></td>
                <td><input type="checkbox" formControlName="delete" /></td>
                <td><input type="checkbox" formControlName="publish" /></td>
            </tr>
            @if (userId) {
                <tr formGroupName="customFields">
                    <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.customFields' | translate }}</td>
                    <td><input type="hidden" /></td>
                    <td><input type="hidden" /></td>
                    <td><input type="checkbox" formControlName="create" /></td>
                </tr>
            }
            <tr class="spacer quarter">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            @for (feature of featureGroups; track feature.id) {
                <tr [formGroupName]="feature.id">
                    <td>{{ feature.name }}</td>
                    <td><input type="checkbox" formControlName="read" /></td>
                    <td><input type="checkbox" formControlName="edit" /></td>
                    <td></td>
                    <td></td>
                </tr>
            }
        </ng-container>

        <tr class="spacer">
            <td colspan="5"></td>
        </tr>

        <ng-container formGroupName="users">
            <tr>
                <td colspan="5">
                    <app-form-error [parentForm]="formGroup" [controlPath]="'permissions.accessToBulkOperations'" />
                </td>
            </tr>
            <tr>
                <th>{{ 'users.userGroups.createEdit.accessSettings.headings.main.brandLevelEdits' | translate }}</th>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.hasAccess' | translate }}</td>
                <td colspan="3"></td>
            </tr>
            <tr formGroupName="accessToBulkOperations">
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.bulkOperation' | translate }}</td>
                <td><input type="checkbox" formControlName="allow" /></td>
                <td colspan="3"></td>
            </tr>

            @let hasListingChannelComparisonEnabled = featureFlagService.featureFlags()[featureFlagEnum.LISTING_CHANNEL_COMPARISON];
            @if (hasListingChannelComparisonEnabled) {
                <tr>
                    <td colspan="5">
                        <app-form-error [parentForm]="formGroup" [controlPath]="'permissions.accessToChannelSnapshotRegeneration'" />
                    </td>
                </tr>
                <tr>
                    <th>{{ 'users.userGroups.createEdit.accessSettings.headings.main.channelExportPreview' | translate }}</th>
                    <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.hasAccess' | translate }}</td>
                    <td colspan="3"></td>
                </tr>
                <tr formGroupName="accessToChannelSnapshotRegeneration">
                    <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.regenerateSnapshots' | translate }}</td>
                    <td><input type="checkbox" formControlName="allow" /></td>
                    <td colspan="3"></td>
                </tr>
            }
        </ng-container>

        <tr class="spacer">
            <td colspan="5"></td>
        </tr>

        @if (featureFlagService.featureFlags()[featureFlagEnum.CONTENT_VISUALS_SPLIT] && supplierUserOrUserGroupHasAccessToVisualsArea()) {
            <app-supplier-user-edit-visuals-permissions
                [permissionData]="visualPermissions()"
                [userId]="userId ? userId : null"
                [groupId]="userGroupId ? userGroupId : null"
            ></app-supplier-user-edit-visuals-permissions>
        }

        <ng-container formGroupName="users">
            <tr>
                <td colspan="5">
                    <app-form-error [parentForm]="formGroup" [controlPath]="'permissions.users'" />
                </td>
            </tr>
            <tr>
                <th>{{ 'users.userGroups.createEdit.accessSettings.headings.main.users' | translate }}</th>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.read' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.edit' | translate }}</td>
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.columns.invite' | translate }}</td>
                <td></td>
                <td></td>
            </tr>
            <tr formGroupName="users">
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.users' | translate }}</td>
                <td><input type="checkbox" formControlName="read" /></td>
                <td><input type="checkbox" formControlName="edit" /></td>
                <td><input type="checkbox" formControlName="invite" /></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="spacer quarter">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr formGroupName="userGroups">
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.userGroups' | translate }}</td>
                <td><input type="checkbox" formControlName="read" /></td>
                <td><input type="checkbox" formControlName="edit" /></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr formGroupName="accessGroups">
                <td>{{ 'users.userGroups.createEdit.accessSettings.headings.rows.accessGroups' | translate }}</td>
                <td><input type="checkbox" formControlName="read" /></td>
                <td><input type="checkbox" formControlName="edit" /></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </ng-container>

        <tr class="spacer">
            <td colspan="5"></td>
        </tr>
    </tbody>
</table>
